import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}
  url: string = `${environment.apiUrl}v1/Auth`;
  getUsers() {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.url}/Users`, { headers });
  }
  updateUser(username: string, data: any) {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.put(`${this.url}/update/${username}`, data, { headers });
  }

  resetPassword(userName: string, newPassword: string) {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.put(
      `${this.url}/reset-password/${userName}`,
      {
        newPassword: newPassword,
      },
      { headers },
    );
  }

  deactivateUser(userName: string) {
    const token = this.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    return this.http.put(`${this.url}/deactivate/${userName}`, {}, { headers });
  }

  reactivateUser(userName: string) {
    const token = this.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.put(`${this.url}/reactivate/${userName}`, {}, { headers });
  }

  addNewUser(userInfo: any) {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.post(`${this.url}/Register`, userInfo, { headers });
  }
  getUserById(userName: string) {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(`${this.url}/${userName}`, { headers });
  }
  login(username: string, password: string) {
    const body = { username, password };
    return this.http.post(`${this.url}/Login`, body, { responseType: 'text' });
  }
  saveToken(token: string) {
    document.cookie = `authToken=${token}; path=/; max-age=21600; SameSite=Lax`;
  }
  getToken(): string | null {
    const name = 'authToken=';
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name)) {
        const token = cookie.substring(name.length);
        return token;
      }
    }
    return null;
  }
  removeToken() {
    document.cookie = 'authToken=; Max-Age=0; path=/';
  }
  deleteUser(userName: string) {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.delete(`${this.url}/DeleteUser/${userName}`, { headers });
  }

  private decodeTokenPayload(): any | null {
    const token = this.getToken();
    if (!token) return null;

    try {
      const payloadBase64 = token.split('.')[1];
      const payloadDecoded = atob(payloadBase64);
      const payloadObject = JSON.parse(payloadDecoded);
      return payloadObject;
    } catch (error) {
      console.error('Invalid token format or decoding error:', error);
      return null;
    }
  }
  getStoreId(): number | null {
    const payloadObject = this.decodeTokenPayload();
    return payloadObject?.StoreId || null;
  }
  getCurrentUsername(): string | null {
    const payloadObject = this.decodeTokenPayload();
    return payloadObject?.username || payloadObject?.sub || null;
  }
  checkRole(): string | null {
    const payloadObject = this.decodeTokenPayload();
    return payloadObject?.role || null;
  }
  hasRole(expectedRole: string): boolean {
    const role = this.checkRole();
    return role === expectedRole;
  }
  getCurrentUser(): any | null {
    const payload = this.decodeTokenPayload();
    if (!payload) return null;
    return {
      username: payload?.username || payload?.sub || null,
      role: payload?.role || null,
      storeName: payload?.StoreName || null,
      storeId: payload?.StoreId || null,
    };
  }
  // saveUserToken(email: string, token: string) {
  //   let tokenMap = JSON.parse(localStorage.getItem('userTokens') || '{}');
  //   tokenMap[email] = token;
  //   localStorage.setItem('userTokens', JSON.stringify(tokenMap));
  // }
  // getUserToken(): { [key: string]: string } {
  //   return JSON.parse(localStorage.getItem('userTokens') || '{}');
  // }
}
